import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsVisibleDisabledNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M23.826 25.593l5.957 5.957 1.768-1.767-5.694-5.694c.496-.419.96-.85 1.39-1.281 2.616-2.617 4.167-5.39 4.533-6.079.243-.459.243-1 0-1.459-.366-.689-1.917-3.462-4.532-6.078C24.64 6.582 20.84 4 16 4c-3.028 0-5.649 1.01-7.826 2.406L2.217.45.45 2.217l5.694 5.694 1.775 1.774 2.327 2.328 1.814 1.813 6.114 6.115 1.814 1.813 2.022 2.023zm.256-3.279l-2.328-2.328a7 7 0 00-9.741-9.741L9.991 8.223C11.746 7.187 13.757 6.5 16 6.5c3.905 0 7.105 2.083 9.48 4.459 1.974 1.975 3.285 4.063 3.846 5.04-.561.979-1.873 3.067-3.846 5.042-.438.438-.904.866-1.398 1.273zm-4.14-4.14l-6.115-6.116a4.5 4.5 0 016.115 6.115zM.22 15.27c.346-.65 1.748-3.16 4.106-5.64l1.768 1.768A25.152 25.152 0 002.674 16c.561.978 1.873 3.066 3.846 5.04 2.375 2.376 5.575 4.46 9.48 4.46 1.274 0 2.473-.222 3.593-.603l1.932 1.93C19.873 27.548 18.028 28 16 28c-4.84 0-8.64-2.583-11.248-5.192-2.615-2.617-4.166-5.39-4.531-6.079-.244-.459-.244-1 0-1.459z" />
        <path d="M9 16c0-.525.058-1.037.168-1.53l8.361 8.362A7 7 0 019 16z" />
      </g>
    </svg>
  )
);
SvgActionsVisibleDisabledNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsVisibleDisabledNormalMedium;
